# Intro

인디게임을 만들다가 게임 기획으로 대학 입학, 학교를 다니면서 또 다른 인디게임을 만들다가 비슷한 계열 회사에서 아르바이트, 졸업 후 일본 워홀을 떠나 요리사로 일하다가 취미로 하던 웹 개발에 빠져 귀국. 그리고 혼자서 웹 프론트엔드 개발 공부, 취업. 그렇게 2018년부터 지금까지 프로그래머로 일하고 있습니다.

프론트엔드라는 분야가 별도의 직군으로 인정받기 시작한 초기부터 개발을 시작했기 때문에 기본적으로 모든 프론트엔드를 책임지는 입장에서 일했으며, 특히 온마이뎁에서는 창업부터 함께 한 만큼 단순한 개발뿐만이 아니라 모든 기술을 고민하고 결정하는 입장에서 일했습니다.

제게 있어서 웹 프론트엔드 개발은 단순한 웹사이트 구축이 아니라, 브라우저 환경에서 동작하는 애플리케이션을 설계하고 최적화하는 과정입니다. 성능 최적화, 상태 관리, 렌더링 전략, 모듈화 아키텍처 등을 항상 고려하며, 개발자 경험을 항상 중시합니다.

서비스 초기 개발부터 운영, 개선, 확장까지 소프트웨어 생애주기 전 과정에 참여했으며, 가장 빠르게 개발하는 방법은 불필요한 프로세스를 제거하고, 팀원간의 원활한 소통과 협업, 그리고 그 모든것을 시스템화 하는데 있다고 생각합니다. 이를 위해 코드 리뷰, 문서화, 테스트 자동화 등을 통해 팀의 생산성을 높이는것을 중요시합니다.
